import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "utils/redux/hooks";
import {
  getCoachBoConversations,
  selectAllChatbotConversations,
  selectGetCoachBoConversationsStatus,
} from "app/containers/Chatbot/slice";

// The user's Coach Bo conversations, fetched the first time any screen needs
// them.
export const useCoachBoConversations = () => {
  const dispatch = useAppDispatch();
  const conversations = useAppSelector(selectAllChatbotConversations);
  const status = useAppSelector(selectGetCoachBoConversationsStatus);

  useEffect(() => {
    if (status === "idle") {
      dispatch(getCoachBoConversations());
    }
  }, [dispatch, status]);

  return { conversations, status };
};
